import Request from './request';



async function fetchOne(code, noResponseError) {
    return Request('get', "api/print-templates/0", { print_template_code: code }, false, noResponseError);
}

async function fetchTemplate(data, noResponseError) {
    return Request('get', "api/print-templates/0", data, false, noResponseError);
}

export default {
    fetchOne,
    fetchTemplate,
};